import { Component, OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { AlarmsService } from '../services/alarms-service.service';
import * as $ from 'jquery/dist/jquery.min.js';
import { DxChartModule, DxChartComponent, DxButtonModule, DxDateBoxModule } from 'devextreme-angular';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
    selector: 'app-vacation-alert',
    templateUrl: './vacaction-alert.component.html',
    styleUrls: ['./vacaction-alert.component.css']
})

export class VacactionAlertComponent implements OnInit {
  showEmailVacation = true;
  showPhoneVacation = false
  oneAtATime = true;
  subscribedVacation = false;
  emailSubscribedVacation = false;
  textSubscribedVacation = false;
  accountVacation: any;
  accountIdVacation: number;
  accountEmailVacation: string;
  accountPhoneVacation: string;
  accountPhonesVacation: string[] = [];
  alarmsVacation: any = {};
  radioModelVacation = 'email';
  deleteTextVacation = false;
  deleteEMailVacation = false;

  enableVacationSave = false;
  vacationBuffer = 0;
  minDateVacation = Date.now();
  startTimeVacation = "";
  endTimeVacation = "";
  isValidDate: boolean;
  isStartDateEmpty = false;
  isEndDateEmpty = false;
  loading = true;
  acctIndexID: any;

  constructor(
    private loginService: LoginService,
    private alarmsService: AlarmsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }

  onSubscribeClickVacation() {
    this.subscribedVacation = true;
  }

  dateValdidation(date) {
    this.isValidDate = this.isInCorrectFormat(date);
  }

  isInCorrectFormat(input) {
    var currVal = input;

    if (currVal === '')
      return false;

    //Declare Regex 
    var rxDatePattern = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/;
    var dtArray = currVal.match(rxDatePattern); // is format OK?

    if (dtArray === null)
      return false;

    //Checks for mm/dd/yyyy format.
    let dtMonth = parseInt(dtArray[1]);
    let dtDay = parseInt(dtArray[3]);
    let dtYear = parseInt(dtArray[5]);

    if (dtMonth < 1 || dtMonth > 12)
      return false;
    else if (dtDay < 1 || dtDay > 31)
      return false;
    else if ((dtMonth === 4 || dtMonth === 6 || dtMonth === 9 || dtMonth === 11) && dtDay === 31)
      return false;
    else if (dtMonth === 2) {
      var isleap = (dtYear % 4 === 0 && (dtYear % 100 !== 0 || dtYear % 400 === 0));
      if (dtDay > 29 || (dtDay === 29 && !isleap))
        return false;
    }
    return true;
  }

  showPhoneSelect() {
    this.showEmailVacation = false;
    this.showPhoneVacation = true;
    this.radioModelVacation = "text";
  }

  showEmailInput() {
    this.showEmailVacation = true;
    this.showPhoneVacation = false;
    this.radioModelVacation = "email";
  }

  setVacationBuffer(val) {
    this.vacationBuffer = val;
  }

  removeVacationAlert(removeText, removeEmail) {
    this.spinnerService.show();
    let deleteModel = {
      OrgUnitId: 0,
      AccountId: this.accountIdVacation,
      RemoveEmail: removeEmail,
      RemoveText: removeText,
      AlarmTypeId: 2
    };
    if (removeEmail) {
      this.alarmsService.deleteAlarm(deleteModel)
        .subscribe((res) => {
          if (res.success === true) {
            console.log('success');
            this.emailSubscribedVacation = false;
          }
          else {
            console.log('failure');
          }
          () => this.spinnerService.hide();
        });
    } else {
      this.alarmsService.deleteAlarm(deleteModel)
        .subscribe((res) => {
          if (res.success === true) {
            console.log('success');
            this.textSubscribedVacation = false;
          }
          else {
            console.log('failure');
          }
          () => this.spinnerService.hide();
        });
    }

  }
  onSaveVacationAlertClick() {
    this.spinnerService.show();
    if (this.startTimeVacation === null || this.startTimeVacation === undefined || this.startTimeVacation === '') {
      this.isStartDateEmpty = true;
    } else {
      this.isStartDateEmpty = false;
    }
    if (this.endTimeVacation === null || this.endTimeVacation === undefined || this.endTimeVacation === '') {
      this.isEndDateEmpty = true;
    } else {
      this.isEndDateEmpty = false;
    }
    if (this.isStartDateEmpty || this.isEndDateEmpty) {
      return;
    }
    else {
      let accountDetails = this.accountVacation.accountDetails[this.acctIndexID].accountDetails;
      let accountsWithDevices = this.accountVacation.accountsWithDevices[this.acctIndexID];

      let orgUnitId = accountsWithDevices.orgUnitId;
      let DeviceId = accountsWithDevices.deviceId;

      let UserId = this.accountVacation.UserId;
      let ContactMethod = this.radioModelVacation;
      let ContactInfoText = '';
      let ContactInfoEmail = '';
      let AlarmType = '';
      if (this.radioModelVacation === "email") {
        ContactInfoText = '';
        ContactInfoEmail = accountDetails.email;
        AlarmType = 'meter-email';
      }
      else {
        ContactInfoText = this.preparePhoneNumberForSaving(this.accountPhoneVacation);
        ContactInfoEmail = '';
        AlarmType = 'meter-text';
      }
      let Active = true;
      let AccountId = accountDetails.accountId;

      let alarmObject = {
        UserId: UserId,
        DeviceId: DeviceId,
        AlarmType: AlarmType,
        ContactMethod: ContactMethod,
        ContactInfoText: ContactInfoText,
        ContactInfoEmail: ContactInfoEmail,
        Active: Active,
        AccountId: AccountId,
        OrgUnitId: orgUnitId,
        AlarmTypeId: 2,
        StartTime: this.startTimeVacation,
        EndTime: this.endTimeVacation,
        Buffer: this.vacationBuffer,
      }
      this.alarmsService.createAlarm(alarmObject)
        .subscribe((res) => {
          if (res.success === true) {
            console.log('success');
            this.alarmsVacation = {};
            this.getVacationAlarms(orgUnitId, DeviceId);
          }
          else {
            console.log('failure');
          }
          () => this.spinnerService.hide();
        });
    }
  }

  ngOnInit() {
    this.spinnerService.show();
    this.loginService.getUserContext()
      .subscribe((account) => {
        this.accountVacation = account;

        this.acctIndexID = this.getActiveAcctIndex(account.accountsWithDevices, account.activeAcctId);

        let accountsWithDevices = account.accountsWithDevices[this.acctIndexID];

        let orgUnitId = accountsWithDevices.orgUnitId;
        let DeviceId = accountsWithDevices.deviceId;
        this.getVacationAlarms(orgUnitId, DeviceId);

        let accountDetails = this.accountVacation.accountDetails[this.acctIndexID].accountDetails;
        this.accountEmailVacation = accountDetails.email;

        if (accountDetails.homePhone !== null) {
          this.accountPhonesVacation.push(this.formatPhoneNumber(accountDetails.homePhone));
        }
        if (accountDetails.cellPhone !== null) {
          this.accountPhonesVacation.push(this.formatPhoneNumber(accountDetails.cellPhone));
        }
        if (accountDetails.businessPhone !== null) {
          this.accountPhonesVacation.push(this.formatPhoneNumber(accountDetails.businessPhone));
        }
        () => this.spinnerService.hide();
      });
  }

  toggleAccordionVacation(open = false) {
    var arrowState = $('.arrowdiv-vacation');
    if (open) {
      arrowState.removeClass("fa-chevron-right");
      arrowState.addClass("fa-chevron-down");
    }
    else {
      if (arrowState.hasClass("fa-chevron-down")) {
        arrowState.removeClass("fa-chevron-down");
        arrowState.addClass("fa-chevron-right");
      } else {
        arrowState.removeClass("fa-chevron-right");
        arrowState.addClass("fa-chevron-down");
      }
    }
  }

  getVacationAlarms(orgUnitId, deviceId) {
    this.alarmsService.getAlarms(orgUnitId, deviceId, "2")
      .subscribe((alarms) => {
        if (alarms.success === false) {
          this.textSubscribedVacation = false;
          this.emailSubscribedVacation = false;
          this.subscribedVacation = false;
          console.log('user has no alarms set');
        }
        else {
          this.subscribedVacation = true;
          this.alarmsVacation = alarms.modelRet;
          this.accountIdVacation = alarms.modelRet.accountId;
          this.startTimeVacation = alarms.modelRet.startTime;
          this.endTimeVacation = alarms.modelRet.endTime;
          this.vacationBuffer = alarms.modelRet.buffer;

          if (alarms.modelRet.contactInfoText !== "" && alarms.modelRet.contactInfoText !== null) {
            this.accountPhoneVacation = this.formatPhoneNumber(alarms.modelRet.contactInfoText);
            this.textSubscribedVacation = true;
          }

          if (alarms.modelRet.contactInfoEmail !== "" && alarms.modelRet.contactInfoEmail !== null) {
            this.emailSubscribedVacation = true;
          }
        }
      });
  }

  preparePhoneNumberForSaving(phoneNumber) {
    var result = phoneNumber.replace(/[- )(]/g, '');
    return result;
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
    return null
  }

  getActiveAcctIndex(accts, activeAcctID) {
    var acctIDIndex = 0;

    //get correct acct based on selected active acctid
    for (var i = 0; i < accts.length; i++) {
      let acct = accts[i];
      if (acct.accountId == activeAcctID) {
        acctIDIndex = i;
        break;
      }
    }
    return acctIDIndex;
  }
}



// WEBPACK FOOTER //
// ./src/app/vacaction-alert/vacaction-alert.component.ts